"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const type_1 = require("../../../type");
const Page_Function_1 = require("../../page/utils/Page.Function");
const Field_Constant_1 = require("../utils/Field.Constant");
const Field_Function_1 = require("../utils/Field.Function");
const FieldUploadFile = ({ props }) => {
    var _a, _b, _c, _d;
    const onClickUpLoadImage = ({ target: { files } }) => __awaiter(void 0, void 0, void 0, function* () {
        if ((files === null || files === void 0 ? void 0 : files.length) > 0) {
            if (props === null || props === void 0 ? void 0 : props.isMultiple) {
                const convert = Array.from(files);
                props === null || props === void 0 ? void 0 : props.setValue(convert);
            }
            else {
                const file = yield files[0];
                props.setValue(file);
            }
        }
        else {
            return;
        }
    });
    const isImage = props.accept.split(",").includes("image/png") ||
        props.accept.split(",").includes("image/jpeg");
    const id = (0, Page_Function_1.FunctionUseId)();
    const isDisabled = typeof props.disabled === type_1.TYPE_FUNCTION
        ? props.disabled(props)
        : props.disabled;
    // console.log(props.value);
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { htmlFor: `index-file-${props.index}-${props.name}-${id}` },
            (props === null || props === void 0 ? void 0 : props.isMultiple) ? (React.createElement(React.Fragment, null, isImage ? (React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.value.length) > 0 ? (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-values ${typeof props.classNameValues === type_1.TYPE_FUNCTION
                    ? props.classNameValues(props)
                    : props.classNameValues}` }, (_a = props === null || props === void 0 ? void 0 : props.value) === null || _a === void 0 ? void 0 : _a.map((row, image_index) => {
                if ((row === null || row === void 0 ? void 0 : row.size) > 0) {
                    return (React.createElement("img", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                            ? props.classNameValue(props)
                            : props.classNameValue}`, src: (0, Field_Function_1.FunctionAddUrlToFile)(row), key: `image-index-${image_index}` }));
                }
                else {
                    return (React.createElement("img", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                            ? props.classNameValue(props)
                            : props.classNameValue}`, key: `image-index-${image_index}`, src: `${props.getPathUrl + props.value}` }));
                }
            }))) : (React.createElement(React.Fragment, null)))) : (React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.value.length) > 0 ? (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-values ${typeof props.classNameValues === type_1.TYPE_FUNCTION
                    ? props.classNameValues(props)
                    : props.classNameValues}` }, (_b = props === null || props === void 0 ? void 0 : props.value) === null || _b === void 0 ? void 0 : _b.map((row, image_index) => {
                if ((row === null || row === void 0 ? void 0 : row.size) > 0) {
                    return (React.createElement("div", { key: `image-index-${image_index}`, className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                            ? props.classNameValue(props)
                            : props.classNameValue}` }, row === null || row === void 0 ? void 0 : row.name));
                }
                else {
                    return (React.createElement("div", { key: `image-index-${image_index}`, className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                            ? props.classNameValue(props)
                            : props.classNameValue}` }, row));
                }
            }))) : (React.createElement(React.Fragment, null)))))) : (React.createElement(React.Fragment, null, isImage
                ? [
                    ((_c = props === null || props === void 0 ? void 0 : props.value) === null || _c === void 0 ? void 0 : _c.size) > 0 ? (React.createElement("img", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                            ? props.classNameValue(props)
                            : props.classNameValue}`, src: (0, Field_Function_1.FunctionAddUrlToFile)(props.value), alt: props.name })) : ([
                        (props === null || props === void 0 ? void 0 : props.value) ? (React.createElement("img", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                                ? props.classNameValue(props)
                                : props.classNameValue}`, src: `${props.getPathUrl + props.value}`, alt: props.name })) : (React.createElement(React.Fragment, null)),
                    ]),
                ]
                : [
                    ((_d = props === null || props === void 0 ? void 0 : props.value) === null || _d === void 0 ? void 0 : _d.size) > 0 ? (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                            ? props.classNameValue(props)
                            : props.classNameValue}` }, props.value.name)) : ([
                        (props === null || props === void 0 ? void 0 : props.value) ? (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-value ${typeof props.classNameValue === type_1.TYPE_FUNCTION
                                ? props.classNameValue(props)
                                : props.classNameValue}` }, props.value)) : (React.createElement(React.Fragment, null)),
                    ]),
                ])),
            React.createElement("div", { className: `` },
                React.createElement("div", { id: props.name, className: `${Field_Constant_1.TEXT_AUTHOR}-input ${typeof props.classNameInput === type_1.TYPE_FUNCTION
                        ? props.classNameInput(props)
                        : props.classNameInput}` }, props.labelUpload || props.labelUpload === ""
                    ? props.labelUpload
                    : Field_Constant_1.TEXT_UPLOAD_FILE[props.language]),
                React.createElement("input", { ref: props.reference, style: {
                        display: "none",
                    }, disabled: isDisabled, multiple: props.isMultiple, accept: props.accept, name: props.name, id: `index-file-${props.index}-${props.name}-${id}`, type: "file", onChange: onClickUpLoadImage })))));
};
exports.default = FieldUploadFile;
